import { TagColors } from '@primitives/Tag/types';

export enum EMPLOYMENT_TYPE {
  PRIVATE_SECTOR = 'Private Sector',
  GOVERNMENT_SECTOR = 'Government Sector',
  SALARIED = 'Salaried',
  SELF_EMPLOYED = 'Self Employed',
  UNEMPLOYED = 'Unemployed',
  STUDENT = 'Student',
  RETIRED = 'Retired',
  HOMEMAKER = 'Homemaker',
  OTHERS = 'Others'
}

export const RiskRating = {
  ['LOW_RISK']: 'LOW_RISK',
  ['MEDIUM_RISK']: 'MEDIUM_RISK',
  ['HIGH_RISK']: 'HIGH_RISK'
};

export type IEscalationInfo = {
  reason: string;
  date: string;
  time: string;
  voc: string;
  createdAt: string;
};
